import { rem, Title } from '@mantine/core';

export function HeroTitle({ ...props }) {
  return (
    <Title fw={500} fz={rem(40)} c="black" lts={-2} {...props}>
      {props.children}
    </Title>
  );
}
